import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 relative overflow-hidden" data-id="element-56">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-57" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-60">
            Obtén el bundle completo de <br className="hidden md:block" data-id="element-61" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-62">
              The Andromeda Protocol
            </span>{' '}
            hoy mismo.
          </h2>

          <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-63">
            (PDF + Checklist + Frameworks). No es un curso de 20 horas; es un
            manual operativo diseñado para que lo leas en 40 minutos y lances
            hoy mismo.
          </p>

          {/* Product mockup image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-12 relative" data-id="element-64">
            <div className="absolute inset-0 bg-purple-600/15 rounded-full blur-[60px] scale-75 pointer-events-none" data-id="element-65" />
            <img src="https://cdn.magicpatterns.com/uploads/1Z6jkShP8LqoxhxriPqEqJ/EL_PROTOCOLO_ANDROMEDA.png" alt="El Protocolo Andromeda - Guía en tablet y móvil" className="relative z-10 w-full max-w-md mx-auto drop-shadow-[0_20px_60px_rgba(124,58,237,0.3)]" data-id="element-66" />
          </motion.div>

          <div className="mb-10" data-id="element-67">
            <span className="text-slate-400 text-lg uppercase tracking-wider font-semibold block mb-2" data-id="element-68">
              Precio Único
            </span>
            <span className="text-6xl md:text-7xl font-extrabold text-red-500 line-through decoration-red-500 decoration-4" data-id="element-69">
              $27 <span className="text-3xl text-red-400" data-id="element-70">USD</span>
            </span>
          </div>

          <div id="offer-cta" className="flex flex-col items-center gap-6" data-id="element-71">
            <CTAButton href="https://myschoolofbusiness.com//cart/47288827838658:1" className="w-full md:w-auto" data-id="element-72">
              QUIERO EL PROTOCOLO ANDROMEDA AHORA — $6.39
            </CTAButton>

            <div className="flex items-center gap-2 text-slate-400 bg-[#161b22] px-4 py-2 rounded-full border border-white/5" data-id="element-73">
              <LockIcon className="w-4 h-4 text-emerald-500" data-id="element-74" />
              <span className="text-sm font-medium" data-id="element-75">
                Acceso inmediato tras la compra. Pago seguro y encriptado.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}